import { createSlice } from '@reduxjs/toolkit';
import { FilterMatchMode } from 'primereact/api';

import {
  countOfOrderSlice,
  countOfOrderSliceFilters,
  countOfOrderTableFilters,
} from '../../components/Admin/TennantBilling/interface/tenantBilling.interface';

const initialState: countOfOrderTableFilters = {
  client_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  year: { value: null, matchMode: FilterMatchMode.CONTAINS },
  month: { value: null, matchMode: FilterMatchMode.CONTAINS },
};

const orderCountFiltersSlice = createSlice({
  name: 'orderCountFilters',
  initialState,
  reducers: {
    updateFilter(state, { payload }: countOfOrderSlice) {
      const { field, value, matchMode } = payload;

      state[field] = {
        value,
        matchMode,
      };
    },

    setAllFilters(_, { payload }: countOfOrderSliceFilters) {
      return payload;
    },

    clearFilters() {
      return initialState;
    },
  },
});

export const { updateFilter, setAllFilters, clearFilters } =
  orderCountFiltersSlice.actions;

export const orderCountFiltersReducer = orderCountFiltersSlice.reducer;
